import React from "react";

// API root for the NHL Game Centre system: "/nhl" (NHL) or "/pwhlx" (PWHL games served in the same shapes).
export const NhlApiBase = React.createContext("/nhl");
